import React, { createContext, useContext } from 'react';
const FormContext = createContext(null);
export const useForm = () => {
    const context = useContext(FormContext);
    if (!context) {
        throw new Error('useForm must be used within FormProvider');
    }
    return context;
};
export const FormProvider = ({ children, uid }) => {
    return React.createElement(FormContext.Provider, { value: { uid: uid } }, children);
};
